export function filterChartRowByTimeScale(date, timeScale) {
  if (!date || isNaN(date)) return false

  switch (timeScale) {
    case 'P1Y':
    case 'A':
      return date.getMilliseconds() === 360 // String(timeValue).match(/^[0-9]{4}/)
    case 'P6M':
    case 'S':
      return date.getMilliseconds() === 180 // String(timeValue).match()
    case 'P3M':
    case 'Q':
      return date.getMilliseconds() === 90 // String(timeValue).match(/^q[0-9]/i)
    case 'P1M':
    case 'M':
      return date.getMilliseconds() === 30 // String(timeValue).match()
    case 'P7D':
    case 'W':
      return date.getMilliseconds() === 7
    case 'P1D':
    case 'D':
      return date.getMilliseconds() === 1 // String(timeValue).match()
    default:
      return false
  }
}

function encodeYearlyDate(date) {
  return String(date.getFullYear())
}

function decodeYearlyDate(dateString) {
  const match = dateString.match(/^([0-9]{4})$/)
  const date = new Date('0-1-1')
  date.setFullYear(+match[1])
  date.setMilliseconds(360)
  return date
}

function encodeSemianualDate(date) {
  return `${date.getFullYear()}`
}

function decodeSemianualDate(dateString) {
  const match = dateString.match(/semianualdatepattern/i)
  match[1]
  const date = new Date('0-1-1')
  date.setMilliseconds(180)
  return date
}

function encodeQuarterlyDate(date) {
  return `${date.getFullYear()}-Q${Math.floor(date.getMonth() / 3) + 1}`
}

function decodeQuarterlyDate(dateString) {
  const match = dateString.match(/^([0-9]{4})-?q([0-4])$/i)
  const date = new Date('0-1-1')
  date.setFullYear(+match[1])
  date.setMonth(match[2] * 3 - 1)
  date.setMilliseconds(90)
  return date
}

function encodeMonthlyDate(date) {
  return `${date.getFullYear()}M${date.getMonth() + 1}`
}

function decodeMonthlyDate(dateString) {
  const match = dateString.match(/monthlydatepattern/i)
  match[1]
  const date = new Date('0-1-1')
  date.setMilliseconds(30)
  return date
}

const WEEKMS = new Date(`0-1-8`).getTime() - new Date('0-1-1').getTime()
function getWeekNumber(date) {
  const onejan = new Date(`${date.getFullYear()}-1-1`)
  return Math.ceil((date.getTime() - onejan.getTime()) / WEEKMS) + 1
}

function weekToMs(weekNumber) {
  return weekNumber * WEEKMS
}

function encodeWeeklyDate(date) {
  return date.getFullYear() + 'W' + getWeekNumber(date)
}

function decodeWeeklyDate(dateString) {
  const match = dateString.match(/^([0-9]{4})w([0-9]{2})$/i)
  const date = new Date('0-1-1')
  date.setFullYear(+match[1])
  const weekMs = weekToMs(+match[2])
  date.setTime(date.getTime() + weekMs)
  date.setMilliseconds(7)
  return date
}

function encodeDalyDate(date) {
  return `${date.getFullYear()}D${date.getDate()}`
}

function decodeDailyDate(dateString) {
  const match = dateString.match(/dailydatepattern/i)
  match[1]
  const date = new Date('0-1-1')
  date.setMilliseconds(1)
  return date
}

export function decodeDate(dateString, scale) {
  if (scale !== void 0) {
    try {
      switch (scale) {
        case 'P1Y':
        case 'A':
          return decodeYearlyDate(dateString)
        case 'P6M':
        case 'S':
          return decodeSemianualDate(dateString)
        case 'P3M':
        case 'Q':
          return decodeQuarterlyDate(dateString)
        case 'P1M':
        case 'M':
          return decodeMonthlyDate(dateString)
        case 'P7D':
        case 'W':
          return decodeWeeklyDate(dateString)
        case 'P1D':
        case 'D':
          return decodeDailyDate(dateString)
        default:
          return NaN
      }
    } catch (e) {
      return NaN
    }
  }

  try {
    return decodeYearlyDate(dateString)
  } catch (e) {
    try {
      return decodeSemianualDate(dateString)
    } catch (e) {
      try {
        return decodeQuarterlyDate(dateString)
      } catch (e) {
        try {
          return decodeMonthlyDate(dateString)
        } catch (e) {
          try {
            return decodeWeeklyDate(dateString)
          } catch (e) {
            try {
              return decodeDailyDate(dateString)
            } catch (e) {
              return NaN
            }
          }
        }
      }
    }
  }
}

export function encodeDate(date) {
  if (
    date !== null &&
    date !== void 0 &&
    !Date.prototype.isPrototypeOf(date) &&
    !isNaN(date) &&
    isFinite(date)
  ) {
    date = new Date(+date)
    if (isNaN(date.getTime())) return null
  } else if (!date || isNaN(date)) {
    return null
  }

  const ms = date.getMilliseconds()
  switch (ms) {
    case 1:
      return encodeDalyDate(date)
    case 7:
      return encodeWeeklyDate(date)
    case 30:
      return encodeMonthlyDate(date)
    case 90:
      return encodeQuarterlyDate(date)
    case 180:
      return encodeSemianualDate(date)
    case 360:
      return encodeYearlyDate(date)
    default:
      return null
  }
}

export function addTimeDelta(date, scale, factor) {
  date = new Date(date)
  factor = isNaN(factor) ? 1 : factor
  if (scale === 'P1Y' || scale === 'A') {
    date.setFullYear(date.getFullYear() + 1 * factor)
  } else if (scale === 'P6M' || scale === 'S') {
    date.setMonth(date.getMonth() + 6 * factor)
  } else if (scale === 'P3M' || scale === 'Q') {
    date.setMonth(date.getMonth() + 3 * factor)
  } else if (scale === 'P1M' || scale === 'M') {
    date.setMonth(date.getMonth() + 1 * factor)
  } else if (scale === 'P7D' || scale === 'W') {
    date.setDate(date.getDate() + 7 * factor)
  } else if (scale === 'P1D' || scale === 'D') {
    date.setDate(date.getDate() + 1 * factor)
  }

  return date
}
